import { Line } from 'react-konva'
import { VisualShape } from 'app/frontend/types/custom/VisualPlan'
import { commonShapeProps, ShapeInteraction } from './shapeInteraction'

type Props = {
  shape: Extract<VisualShape, { type: 'triangle' }>
  width: number
  height: number
  interaction?: ShapeInteraction
}

const TriangleShape = ({ shape, width, height, interaction }: Props) => {
  const centerX = shape.x * width
  const centerY = shape.y * height
  const pw = shape.width * width
  const ph = shape.height * height
  const points = [0, -ph / 2, pw / 2, ph / 2, -pw / 2, ph / 2]

  return (
    <Line
      ref={interaction?.nodeRef}
      x={centerX}
      y={centerY}
      points={points}
      closed
      rotation={shape.rotation ?? 0}
      fill={shape.fill_rgb}
      {...commonShapeProps(shape)}
      draggable={interaction?.draggable ?? false}
      listening={interaction !== undefined}
      onMouseEnter={interaction?.onMouseEnter}
      onMouseLeave={interaction?.onMouseLeave}
      onMouseDown={interaction?.onMouseDown}
      onTap={interaction?.onTap}
      onDragStart={interaction?.onDragStart}
      onDragMove={interaction?.onDragMove}
      onDragEnd={interaction?.onDragEnd}
    />
  )
}

export default TriangleShape
